import { render, staticRenderFns } from "./GoTo.vue?vue&type=template&id=54cbd387&scoped=true&"
import script from "./GoTo.vue?vue&type=script&lang=ts&"
export * from "./GoTo.vue?vue&type=script&lang=ts&"
import style0 from "./GoTo.vue?vue&type=style&index=0&id=54cbd387&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cbd387",
  null
  
)

export default component.exports